import { apiClient } from './authService';

export const bwService = {
  async convert({
    file = null,
    sourceJobId = null,
    sourceVariant = null,
    maxFileSizeMb = 50.0,
    claheClip,
    tileSize,
    illuminationKernel,
    illuminationStrength,
    gamma,
    sharpenStrength,
    brightnessAdj,
    contrastBoost,
    signal = null,
  }) {
    const hasUpload = Boolean(file);
    const hasSource = Boolean(sourceJobId && sourceVariant);
    if (!hasUpload && !hasSource) {
      throw new Error('B/W conversion requires an uploaded file or source artifact reference.');
    }
    if (hasUpload && hasSource) {
      throw new Error('Provide either file upload or source artifact reference, not both.');
    }

    const formData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    if (sourceJobId) {
      formData.append('source_job_id', sourceJobId);
    }
    if (sourceVariant) {
      formData.append('source_variant', sourceVariant);
    }

    if (typeof maxFileSizeMb === 'number') {
      formData.append('max_file_size_mb', String(maxFileSizeMb));
    }

    if (typeof claheClip === 'number') {
      formData.append('clahe_clip', String(claheClip));
    }
    if (typeof tileSize === 'number') {
      formData.append('tile_size', String(tileSize));
    }
    if (typeof illuminationKernel === 'number') {
      formData.append('illumination_kernel', String(illuminationKernel));
    }
    if (typeof illuminationStrength === 'number') {
      formData.append('illumination_strength', String(illuminationStrength));
    }
    if (typeof gamma === 'number') {
      formData.append('gamma', String(gamma));
    }
    if (typeof sharpenStrength === 'number') {
      formData.append('sharpen_strength', String(sharpenStrength));
    }
    if (typeof brightnessAdj === 'number') {
      formData.append('brightness_adj', String(brightnessAdj));
    }
    if (typeof contrastBoost === 'number') {
      formData.append('contrast_boost', String(contrastBoost));
    }

    const response = await apiClient.post('/bw/convert', formData, {
      responseType: 'blob',
      // Cloudflare will return a 524 around ~100s if the origin doesn't respond.
      // Prefer surfacing a clear client-side timeout instead of a vague CORS error.
      timeout: 95000,
      signal: signal || undefined,
    });

    return response.data;
  },
};

export default bwService;
